import { useMemo } from 'react';
import { useEventsQuery } from '../generated/graphql';

export const useHasPrivateEvent = (): boolean => {
  const { data } = useEventsQuery();
  return useMemo(() => {
    // Private = visible false
    return data?.events.some(e => e.visible === false) || false;
  }, [data]);
};
